
 let removeButtons = document.querySelectorAll("custom-remove"); // Adjust the selector as needed
 let cartDrawerRemoveButtons = document.querySelectorAll("custom-remove-drawer");
   if(removeButtons.length > 0){
     removeButtons.forEach((removeButton) => removeButton.addEventListener("click", function(event) {
       let removeButtonProp = event.target.closest(".custom-remove-button").getAttribute("data-bundle-id");
        const button = event.target.closest(".custom-remove-button");
  
        
        // Add loading state
        button.disabled = true;
        button.classList.add("loading");
       let intervalId = setInterval(() => {
         fetch(window.Shopify.routes.root + 'cart.js')
           .then(response => {
             if (!response.ok) {
               throw new Error('Failed to fetch cart');
             }
             return response.json();
           })
           .then(cart => {
             console.log(cart)
             let updates = {};
             let hasMainProduct = false;
     
               console.log(removeButtonProp)
             cart.items.forEach(item => {
               if (item.properties && removeButtonProp === item.properties._bundleId ) {
                 updates[item.id] = 0;
                 hasMainProduct = true;
               }
             });
     
             if (hasMainProduct) {
               return fetch(window.Shopify.routes.root + 'cart/update.js', {
                 method: 'POST',
                 headers: {
                   'Content-Type': 'application/json'
                 },
                 body: JSON.stringify({ updates: updates })
               });
             } else {
               clearInterval(intervalId);
               console.log('All main_product items have been removed');
               window.location.reload();
               return Promise.reject('No items to update');
             }
           })
           .then(response => {
             if (!response.ok) {
               throw new Error('Failed to update cart');
             }
             return response.json();
           })
           .then(data => {
             console.log('Cart updated:', data);
             // Uncomment the line below to reload the page after the update
             // window.location.reload();
           })
           .catch(error => {
             if (error !== 'No items to update') {
               console.error('Error:', error);
               alert(`There was an error: ${error.message}. Please try again.`);
               clearInterval(intervalId);
             }
           });
                 
       }, 2000); // Check every 2 seconds (adjust the interval as needed)
     }));
   }
   if(cartDrawerRemoveButtons.length > 0){
     cartDrawerRemoveButtons.forEach((cartDrawerRemoveButton) => cartDrawerRemoveButton.addEventListener("click", function(event) {
       let intervalId = setInterval(() => {
         fetch(window.Shopify.routes.root + 'cart.js')
           .then(response => {
             if (!response.ok) {
               throw new Error('Failed to fetch cart');
             }
             return response.json();
           })
           .then(cart => {
             let updates = {};
             let hasMainProduct = false;
     
             cart.items.forEach(item => {
               let removeButtonProp = event.target.closest("custom-remove-drawer").getAttribute("data-bundle-id");
               if (item.properties && item.properties._bundleId === removeButtonProp) {
                 updates[item.id] = 0;
                 hasMainProduct = true;
               }
             });
     
             if (hasMainProduct) {
               return fetch(window.Shopify.routes.root + 'cart/update.js', {
                 method: 'POST',
                 headers: {
                   'Content-Type': 'application/json'
                 },
                 body: JSON.stringify({ updates: updates })
               });
             } else {
               clearInterval(intervalId);
               console.log('All main_product items have been removed');
               fetch(`${routes.cart_url}?section_id=cart-drawer`)
               .then((response) => response.text())
               .then((responseText) => {
                   const html = new DOMParser().parseFromString(responseText, 'text/html');
                   const selectors = ['cart-drawer-items', '.cart-drawer__footer', '#cart-icon-bubble'];
                   for (const selector of selectors) {
                     const targetElement = document.querySelector(selector);
                     const sourceElement = html.querySelector(selector);
                     if (targetElement && sourceElement) {
                       targetElement.replaceWith(sourceElement);
                       
                     }
                 }
               });
               window.location.reload();
               return Promise.reject('No items to update');
             }
           })
           .then(response => {
             if (!response.ok) {
               throw new Error('Failed to update cart');
             }
             return response.json();
           })
           .then(data => {
             console.log('Cart updated:', data);
             // Uncomment the line below to reload the page after the update
             // window.location.reload();
           })
           .catch(error => {
             if (error !== 'No items to update') {
               console.error('Error:', error);
               alert(`There was an error: ${error.message}. Please try again.`);
               clearInterval(intervalId);
             }
           });
                 
       }, 2000); // Check every 2 seconds (adjust the interval as needed)
     }));
   }